import React from 'react';

const iconRobot = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_3534_35440"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="100"
      height="100"
    >
      <circle cx="50" cy="50" r="50" fill="white" />
    </mask>
    <g mask="url(#mask0_3534_35440)">
      <rect
        x="-21.7285"
        y="-1.04395"
        width="138.462"
        height="176.044"
        fill="#FFD525"
      />
      <g clipPath="url(#clip0_3534_35440)">
        <path
          d="M61.7924 70.0964C61.7924 72.0437 57.3513 73.5834 51.8679 73.5834C46.3845 73.5834 41.9434 71.9984 41.9434 70.0964C41.9434 68.1944 46.3845 66.6094 51.8679 66.6094C57.3513 66.6094 61.7924 68.1491 61.7924 70.0964Z"
          fill="#83BB26"
        />
        <path
          d="M61.7924 74.3986C61.7924 76.3459 57.3513 77.8857 51.8679 77.8857C46.3845 77.8857 41.9434 76.3006 41.9434 74.3986C41.9434 72.4966 46.3845 70.9116 51.8679 70.9116C57.3513 70.8663 61.7924 72.4513 61.7924 74.3986Z"
          fill="#83BB26"
        />
        <path
          d="M76.7934 119.006C76.9747 120.228 75.8871 121.451 74.301 121.632C59.3915 123.579 44.4821 123.579 29.5727 121.632C27.9866 121.406 26.899 120.228 27.0803 119.006C29.2555 105.057 29.2555 91.1093 27.0803 77.2065C26.899 75.9837 27.9866 74.761 29.5727 74.5799C44.4821 72.6326 59.3915 72.6326 74.301 74.5799C75.8871 74.8063 76.9747 75.9837 76.7934 77.2065C74.5729 91.1093 74.5729 105.057 76.7934 119.006Z"
          fill="#F7A600"
        />
        <path
          d="M102.486 135.267L98.6792 134.271C102.395 120.096 99.7668 106.375 90.8393 93.5135C84.087 83.777 76.1111 78.2068 76.0205 78.1615L78.2411 74.9009C78.6036 75.1274 86.8514 80.8787 94.0115 91.1586C103.528 104.88 106.474 120.142 102.486 135.267Z"
          fill="#83BB26"
        />
        <path
          d="M85.0866 74.9915C86.0836 78.5238 83.999 82.1467 80.5095 83.143C76.9748 84.1393 73.3494 82.0561 72.3524 78.5691C71.3554 75.0368 73.3947 71.3686 76.9295 70.4176C80.4189 69.4213 84.0896 71.4592 85.0866 74.9915Z"
          fill="#1DBADF"
        />
        <path
          d="M101.674 99.6272C102.444 102.344 100.858 105.152 98.1392 105.922C95.4202 106.692 92.6105 105.107 91.8401 102.39C91.0697 99.6725 92.6558 96.8195 95.3749 96.0949C98.0939 95.325 100.904 96.91 101.674 99.6272Z"
          fill="#1DBADF"
        />
        <path
          d="M0.342285 137.392L4.14894 136.396C0.43292 122.221 3.06133 108.499 11.9888 95.638C18.7411 85.9015 26.717 80.3313 26.8076 80.286L24.5871 77.0254C24.2245 77.2518 15.9768 83.0032 8.81663 93.2831C-0.700014 106.96 -3.64564 122.221 0.342285 137.392Z"
          fill="#83BB26"
        />
        <path
          d="M17.7446 77.0704C16.7477 80.6028 18.8323 84.2256 22.3217 85.2219C25.8565 86.2182 29.4818 84.1351 30.4788 80.648C31.4758 77.1157 29.4365 73.4475 25.9018 72.4965C22.4123 71.5002 18.7416 73.5381 17.7446 77.0704Z"
          fill="#1DBADF"
        />
        <path
          d="M1.15653 101.706C0.38613 104.423 1.97224 107.231 4.69128 108.001C7.41032 108.771 10.22 107.186 10.9904 104.469C11.7608 101.752 10.1747 98.8985 7.45564 98.174C4.7366 97.4041 1.92692 98.9891 1.15653 101.706Z"
          fill="#1DBADF"
        />
        <path
          d="M60.1635 84.271C56.81 84.271 53.9097 86.173 52.4596 88.9355C51.0094 86.173 48.1091 84.271 44.7556 84.271C39.952 84.271 36.0547 88.1656 36.0547 92.9659C36.0547 104.333 52.4596 113.39 52.4596 113.39C52.4596 113.39 54.8614 112.077 57.8523 109.812C59.9823 108.182 62.3841 106.099 64.378 103.653C66.9611 100.574 68.9098 96.9058 68.9098 93.0112C68.8645 88.1656 64.9672 84.271 60.1635 84.271Z"
          fill="#FF2180"
        />
        <path
          d="M49.7412 37.4906C50.6929 35.2263 51.7805 33.0978 52.8228 31.0147C55.0433 26.6672 57.0826 22.5915 57.8077 17.6553L59.4391 17.8817C58.7141 23.0896 56.5841 27.3012 54.3183 31.7393C53.276 33.7771 52.1883 35.9056 51.282 38.1246L49.7412 37.4906Z"
          fill="#4C291B"
        />
        <path
          d="M43.5758 34.728C42.2163 32.6901 40.7208 30.7881 39.316 28.9314C36.2797 25.1273 33.4701 21.5044 31.8386 16.7947L30.2979 17.3381C32.0199 22.2743 34.9202 26.033 38.0018 29.9729C39.4066 31.7844 40.8568 33.6411 42.2163 35.6337L43.5758 34.728Z"
          fill="#4C291B"
        />
        <path
          d="M18.5624 54.1105C18.9703 58.3674 20.6924 61.6733 22.4144 61.4922C24.1365 61.311 25.1788 57.7787 24.7709 53.5218C24.3631 49.2649 22.641 45.959 20.9189 46.1402C19.2422 46.276 18.1546 49.8536 18.5624 54.1105Z"
          fill="#83BB26"
        />
        <path
          d="M75.8427 48.5856C76.2506 52.8425 77.9726 56.1484 79.6947 55.9673C81.4168 55.7861 82.459 52.2538 82.0512 47.9969C81.6433 43.74 79.9213 40.4341 78.1992 40.6153C76.5225 40.7964 75.4349 44.374 75.8427 48.5856Z"
          fill="#83BB26"
        />
        <path
          d="M78.3783 40.3888L75.342 40.6605C70.2211 34.6375 59.9794 31.0599 48.5594 32.1467C37.1394 33.2789 27.7588 38.7132 23.8615 45.642L20.8252 45.9137L22.366 61.6733L25.4023 61.4016C30.5231 67.4246 40.7648 71.0022 52.1848 69.9154C63.6048 68.8285 72.9855 63.3942 76.8375 56.4654L79.8737 56.1937L78.3783 40.3888Z"
          fill="#F7A600"
        />
        <path
          d="M41.9403 53.1549C45.9999 53.1549 49.2908 49.8663 49.2908 45.8095C49.2908 41.7528 45.9999 38.4641 41.9403 38.4641C37.8808 38.4641 34.5898 41.7528 34.5898 45.8095C34.5898 49.8663 37.8808 53.1549 41.9403 53.1549Z"
          fill="white"
        />
        <path
          d="M57.6602 48.7848C60.521 48.7848 62.84 46.4673 62.84 43.6086C62.84 40.7498 60.521 38.4324 57.6602 38.4324C54.7995 38.4324 52.4805 40.7498 52.4805 43.6086C52.4805 46.4673 54.7995 48.7848 57.6602 48.7848Z"
          fill="white"
        />
        <path
          d="M42.5709 49.9985C45.1638 49.9985 47.2657 47.898 47.2657 45.3069C47.2657 42.7158 45.1638 40.6152 42.5709 40.6152C39.9779 40.6152 37.876 42.7158 37.876 45.3069C37.876 47.898 39.9779 49.9985 42.5709 49.9985Z"
          fill="#83BB26"
        />
        <path
          d="M57.5049 46.9553C59.3845 46.9553 60.9082 45.4326 60.9082 43.5543C60.9082 41.676 59.3845 40.1533 57.5049 40.1533C55.6253 40.1533 54.1016 41.676 54.1016 43.5543C54.1016 45.4326 55.6253 46.9553 57.5049 46.9553Z"
          fill="#83BB26"
        />
        <path
          d="M44.4347 49.6272C41.9876 50.6235 39.2232 49.5366 38.2262 47.1365C37.2292 44.7363 38.4075 41.9738 40.8093 40.9775C43.2111 39.9813 46.0208 41.0681 47.0178 43.4683C48.0148 45.8684 46.8818 48.6309 44.4347 49.6272Z"
          fill="#83BB26"
        />
        <path
          d="M54.2257 42.6985C53.8632 44.4646 55.0414 46.2308 56.8541 46.5931C58.6668 46.9554 60.4795 45.8232 60.842 44.0571C61.2046 42.2909 60.0263 40.5247 58.2136 40.1625C56.4009 39.8002 54.5882 40.9323 54.2257 42.6985Z"
          fill="#83BB26"
        />
        <path
          d="M42.675 48.0286C44.2818 48.0286 45.5844 46.7269 45.5844 45.1212C45.5844 43.5155 44.2818 42.2139 42.675 42.2139C41.0682 42.2139 39.7656 43.5155 39.7656 45.1212C39.7656 46.7269 41.0682 48.0286 42.675 48.0286Z"
          fill="#1D1D1B"
        />
        <path
          d="M57.4919 45.4971C58.6633 45.4971 59.6128 44.5482 59.6128 43.3777C59.6128 42.2072 58.6633 41.2583 57.4919 41.2583C56.3206 41.2583 55.3711 42.2072 55.3711 43.3777C55.3711 44.5482 56.3206 45.4971 57.4919 45.4971Z"
          fill="#1D1D1B"
        />
        <path
          d="M42.4891 47.1816C42.3984 47.7703 41.8546 48.1326 41.2655 48.0421C40.6764 47.9515 40.3138 47.408 40.4045 46.8193C40.4951 46.2306 41.0389 45.8683 41.628 45.9589C42.1718 46.0947 42.5797 46.6382 42.4891 47.1816Z"
          fill="white"
        />
        <path
          d="M57.8962 44.7815C58.0321 45.1891 58.4853 45.3702 58.8479 45.2344C59.2557 45.0985 59.437 44.6456 59.301 44.2834C59.1651 43.8758 58.7119 43.6946 58.3494 43.8305C57.9415 43.9664 57.7602 44.3739 57.8962 44.7815Z"
          fill="white"
        />
        <path
          d="M28.8498 24.0406C25.4963 23.2254 23.5023 19.829 24.3181 16.5231C25.1338 13.1719 28.5326 11.1793 31.8407 11.9945C35.1942 12.8096 37.1882 16.2061 36.3725 19.5119C35.5568 22.8178 32.2033 24.8557 28.8498 24.0406Z"
          fill="#83BB26"
        />
        <path
          d="M30.2508 15.6174C30.2508 14.6663 29.4804 13.8965 28.5287 13.8965C27.577 13.8965 26.8066 14.6663 26.8066 15.6174C26.8066 16.5684 27.577 17.3382 28.5287 17.3382C29.4804 17.3382 30.2508 16.6137 30.2508 15.6174Z"
          fill="white"
        />
        <path
          d="M60.4793 22.7271C63.0624 22.0931 64.6032 19.4665 63.9687 16.9305C63.3343 14.3492 60.7059 12.8094 58.1681 13.4434C55.585 14.0774 54.0442 16.704 54.6786 19.2401C55.3131 21.8214 57.8962 23.3611 60.4793 22.7271Z"
          fill="#83BB26"
        />
        <path
          d="M59.3896 16.2514C59.3896 15.5268 59.9788 14.8928 60.7492 14.8928C61.4742 14.8928 62.1087 15.4815 62.1087 16.2514C62.1087 17.0213 61.5196 17.61 60.7492 17.61C59.9788 17.61 59.3896 17.0213 59.3896 16.2514Z"
          fill="white"
        />
        <path
          d="M42.6221 56.737C43.3018 60.4505 48.0148 62.7601 53.181 61.8544C58.3472 60.9486 62.0179 57.1899 61.3835 53.4312"
          stroke="#FF2180"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3534_35440">
        <rect
          width="110.769"
          height="141.429"
          fill="white"
          transform="translate(-3.92578 11.8132)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default iconRobot;
